import { render, staticRenderFns } from "./MedicamentosRecetados.vue?vue&type=template&id=25234db6&scoped=true"
import script from "./MedicamentosRecetados.vue?vue&type=script&lang=js"
export * from "./MedicamentosRecetados.vue?vue&type=script&lang=js"
import style0 from "./MedicamentosRecetados.vue?vue&type=style&index=0&id=25234db6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25234db6",
  null
  
)

export default component.exports